import Helper from './Helper';
import LazyLoad from 'vanilla-lazyload';
import Overlay from './Overlay';

class ProjectTeaser {
  constructor() {
    this.body = document.querySelector("body");
    this.content = document.querySelector('.content');
    this.contentSide = document.querySelector('.content__side');

    this.classClose = '.close';
    this.classPrevNext = '.prev-next__link';
    this.classProjects = '.ns-project-teaser__link';
    this.classProjectContent = '.ns-project-container__content';

    this.hash = window.location.hash;

    const projects = document.querySelectorAll(this.classProjects);

    if (!!projects.length) {
      this.bindOpenOverlay(projects);
    }
  }

  bindOpenOverlay(projects, ca4n = false){
    projects.forEach(project => {
      project.classList.add('loaded');

      project.addEventListener("click", (e) => {
        e.preventDefault();

        document.querySelector('html').classList.add("ns-p-loading");

        let overlayContainer = `<div class="ns-overlay ns-overlay--projekt show"><div class="ns-overlay__background"></div>`;

        let pageToDisplay = project.href;
        let xhr = new XMLHttpRequest();

        xhr.onreadystatechange = () => {
          if(xhr.readyState === 4) {
            if(xhr.status === 200) {

              document.querySelector('html').classList.remove("ns-p-loading");

              let parser = new DOMParser();
              let dom = parser.parseFromString(xhr.responseText, 'text/html');

              overlayContainer += dom.querySelector('.content').innerHTML + dom.querySelector('.content__side').innerHTML;

              let language = document.querySelector("html").getAttribute("lang");
              let backto, closeproject;

              if(language == "de-DE"){
                backto = "Zurück zur Übersicht";
                closeproject = "Projekt schließen";
              } else {
                backto = "Back to overview";
                closeproject = "Close Project";
              }

              if(project.closest(".content") === null && ca4n === false){
                overlayContainer +=  `<div class="sidebar sidebar--close">
                                        <span class="sidebar__button close">
                                          <span class="sidebar__icon"></span>
                                          <span class="sidebar__text">${backto}</span>
                                        </span>
                                      </div>`;
                overlayContainer += `</div></div>`;
                ca4n = false;
              } else {
                overlayContainer +=  `<div class="sidebar sidebar--close">
                                        <span class="sidebar__button close closeall">
                                          <span class="sidebar__icon"></span>
                                          <span class="sidebar__text">${closeproject}</span>
                                        </span>
                                      </div>`;
                overlayContainer += `</div></div>`;
                ca4n = true;
              }

              if(this.contentSide.querySelector('.ns-overlay--projekt')) this.contentSide.querySelector('.ns-overlay--projekt').remove();

              this.contentSide.innerHTML += overlayContainer;

              let closeButtonInner = ``;


              if(project.closest(".content") === null){
                closeButtonInner += `<span class="ns-button__inner close">`;
              } else {
                closeButtonInner += `<span class="ns-button__inner close closeandload">`;
              }

              closeButtonInner += `<span class="ns-button__icon"></span>
                                   <span class="ns-button__text">${backto}</span>
                                  </span>`;

              document.querySelector('.ns-overlay--projekt').querySelector(this.classProjectContent).innerHTML += closeButtonInner;

              this.bindOpenOverlay(document.querySelector('.ns-overlay--projekt').querySelectorAll(this.classPrevNext), ca4n);
              this.closeOverlay(document.querySelector('.ns-overlay--projekt').querySelectorAll(this.classClose))

              this.body.classList.add("overlay-open");
              this.body.classList.add('overlay-project-open');
              this.content.classList.add("content--inactive");

              window.scrollTo(0,0);

              new LazyLoad();

              let canonical = dom.querySelector('link[rel="canonical"]').getAttribute('href')
              let url = window.location.origin + window.location.pathname;
              let splitted = url.split('/');
              splitted.length = 6;
              let joined = splitted.join('/');
              canonical = canonical.replace(joined,'').replace('/', '');
              let urlPath = window.location.origin + window.location.pathname + "#" + canonical.replace('/', '');
              window.history.pushState("","", urlPath);

            }
          }
        }

        xhr.open('GET', pageToDisplay);

        xhr.send(null);

      });
    });
  }

  closeOverlay(closeButtons) {
    closeButtons.forEach(close => {
      close.addEventListener("click", e => {
        if(this.contentSide.querySelector('.ns-overlay--projekt')) this.contentSide.querySelector('.ns-overlay--projekt').remove();

        if(close.classList.contains("closeall") || close.classList.contains("closeandload")) {
          this.body.classList.remove("overlay-open");
          this.content.classList.remove("content--inactive");

          this.overlayInstance = new Overlay({
            overlayButtonSelector: '.sidebar__button[href]',
            overlayTagmagButtonSelector: '.sidebar__button--tagfilter',
            openerSelector: ".js-tagmag-box",
            openerTagSelector: ".js-tagmag-box-name"
          });

        } else {
          this.bindOpenOverlay(document.querySelectorAll(this.classProjects));
          this.closeProjectsOverlay(document.querySelectorAll(this.classClose));
        }

        this.body.classList.remove('overlay-project-open');

        if(close.classList.contains("closeandload") && document.querySelector('.sidebar__button--projekte')){
          let clickEvent = new Event('click');
          document.querySelector('.sidebar__button--projekte').dispatchEvent(clickEvent);
        }

        new LazyLoad();

        let urlPath = window.location.origin + window.location.pathname + this.hash;
        window.history.pushState("","", urlPath);
      });
    });
  }

  closeProjectsOverlay(closeButtons) {
    closeButtons.forEach(close => {
      close.addEventListener("click", (e) => {
        const overlayElement = document.querySelector('.ns-overlay');
        const overlayInnerElement = document.querySelector('.ns-overlay__inner');
        const sidenav = document.querySelector('.sidenav');
        const sidebar = document.querySelector('.sidebar');

        this.body.classList.remove('overlay-open', 'no-scroll');
        this.content.classList.remove("content--inactive");

        sidenav.style.display = "block";
        sidebar.style.display = "grid";

        overlayElement.classList.remove('show', 'ns-overlay--projekte', 'ns-overlay--factsheet');
        overlayInnerElement.innerHTML = "";

        Helper.fade(overlayElement);

        new Overlay({
          overlayButtonSelector: '.sidebar__button[href]',
          overlayTagmagButtonSelector: '.sidebar__button--tagfilter'
        });

        let urlPath = window.location.origin + window.location.pathname;
        window.history.pushState("","", urlPath);
      });
    });
  }
} export default ProjectTeaser;
